/**
 * The slugmap is designed a way to shorten window.DDC lookups.
 * Instead of having to type [[dataLayer.dealership.address1]] you can do [[address1]]
 * Note: currently vehicles have a special statment to handle them, thus their lookup is local to the vehicle.
 */
export default {
	address1: 'dataLayer.dealership.address1',
	address2: 'dataLayer.dealership.address2',
	bodyStyle: 'vehicle.bodyStyle',
	certified: 'vehicle.certified',
	city: 'dataLayer.dealership.city',
	cityFuelEfficiency: 'vehicle.cityFuelEfficiency',
	chromeId: 'vehicle.chromeId',
	dealershipName: 'dataLayer.dealership.dealershipName',
	driveLine: 'vehicle.driveLine',
	exteriorColor: 'vehicle.exteriorColor',
	highwayFuelEfficiency: 'vehicle.highwayFuelEfficiency',
	internetPrice: 'vehicle.internetPrice',
	inventoryType: 'vehicle.inventoryType',
	layoutType: 'dataLayer.page.attributes.layoutType',
	locale: 'dataLayer.page.attributes.locale',
	make: 'vehicle.make',
	model: 'vehicle.model',
	newOrUsed: 'vehicle.newOrUsed',
	normalBodyStyle: 'vehicle.normalBodyStyle',
	odometer: 'vehicle.odometer',
	pageAlias: 'dataLayer.page.pageInfo.pageName',
	pageId: 'dataLayer.page.pageInfo.pageId',
	pageTrackMake: 'dataLayer.page.trackingTags.make',
	pageTrackModel: 'dataLayer.page.trackingTags.model',
	pageTrackYear: 'dataLayer.page.trackingTags.year',
	postalCode: 'dataLayer.dealership.postalCode',
	prevVehicleResultCount: 'dataLayer.prev.page.attributes.vehicleResultCount',
	queryFacets: 'dataLayer.page.queryFacets',
	returnNull: null,
	stateProvince: 'dataLayer.dealership.stateProvince',
	stockNumber: 'vehicle.stockNumber',
	trim: 'vehicle.trim',
	userId: 'userProfile.universalUserId',
	uuid: 'vehicle.uuid',
	vehicleAccountId: 'vehicle.accountId',
	vehicleResultCount: 'dataLayer.page.attributes.vehicleResultCount',
	vin: 'vehicle.vin',
	website: 'dataLayer.dealership.website',
	year: 'vehicle.modelYear',
	zip: 'dataLayer.confirmation.zip',
	inventoryDate: 'vehicle.inventoryDate',
	fuelType: 'vehicle.fuelType',
	msrp: 'vehicle.msrp'
};
